import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoPersonCircleOutline, IoSettingsOutline, IoLogOutOutline } from "react-icons/io5";
import { getSessionContext, hasFamilyClientSelection } from "../../common/utils/sessionContext";
import { performSessionLogout } from "../../common/utils/authSession";
import Confirmation from "../../common/components/Confirmation";
import FamilySidebar from "./FamilySidebar";

const FamilyHeader = ({ variant = "default" }) => {
  const navigate = useNavigate();
  const { familyClientName } = getSessionContext();
  const showLogoHeader = variant === "select" || !hasFamilyClientSelection();
  const showProfileDropdown = showLogoHeader;
  const [showSideBar, setShowSideBar] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const profileMenuRef = useRef(null);

  const closeSideBar = () => {
    setShowSideBar(false);
  };

  const handleLogoutConfirm = async (e) => {
    e?.preventDefault?.();
    setShowLogoutPopup(false);
    await performSessionLogout({ navigate });
  };

  const openSettings = () => {
    setShowProfileMenu(false);
    navigate("/family-settings");
  };

  const openLogout = () => {
    setShowProfileMenu(false);
    setShowLogoutPopup(true);
  };

  const handleProfileIconClick = () => {
    if (showProfileDropdown) {
      setShowProfileMenu((open) => !open);
      return;
    }
    navigate("/family-settings");
  };

  useEffect(() => {
    if (!showProfileMenu) {
      return undefined;
    }
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showProfileMenu]);

  return (
    <>
      <div className="header-container header-no-border-bottom family-header">
        <div className="family-header-left">
          {showLogoHeader ? (
            <img
              src={require("../../assets/btTree.png")}
              className="family-header-logo"
              alt="BridgeTree"
            />
          ) : showSideBar ? (
            <FamilySidebar showSideBar={closeSideBar} showHamBergIcon={closeSideBar} onLogoutClick={() => setShowLogoutPopup(true)} />
          ) : (
            <GiHamburgerMenu className="caregiver-header-icon" onClick={() => setShowSideBar(true)} aria-label="Open menu" />
          )}
        </div>

        <div className="family-header-center">
          {!showLogoHeader && familyClientName ? (
            <span className="family-header-client-name">{familyClientName}</span>
          ) : null}
        </div>

        <div className="family-header-right family-profile-wrap" ref={profileMenuRef}>
          <button
            type="button"
            className="family-profile-btn"
            onClick={handleProfileIconClick}
            aria-label={showProfileDropdown ? "Profile menu" : "Go to profile"}
            aria-expanded={showProfileDropdown ? showProfileMenu : undefined}
            aria-haspopup={showProfileDropdown ? "menu" : undefined}>
            <IoPersonCircleOutline />
          </button>

          {showProfileDropdown && showProfileMenu ? (
            <div className="family-profile-menu" role="menu">
              <button type="button" className="family-profile-menu-item" role="menuitem" onClick={openSettings}>
                <IoSettingsOutline aria-hidden="true" />
                <span>Profile</span>
              </button>
              <button type="button" className="family-profile-menu-item family-profile-menu-item--logout" role="menuitem" onClick={openLogout}>
                <IoLogOutOutline aria-hidden="true" />
                <span>Logout</span>
              </button>
            </div>
          ) : null}
        </div>
      </div>

      <Confirmation content="Are you sure you want to logout?" open={showLogoutPopup} closeConfirmation={() => setShowLogoutPopup(false)} processCallback={(e) => handleLogoutConfirm(e)} />
    </>
  );
};

export default FamilyHeader;
